import { action, observable } from "mobx";
import NestStore from "~/stores/NestStore";
import PhotoEditingLabelRepository from "../../repository/PhotoEditing/PhotoEditingLabelRepository";

class PhotoEditingLabelStore extends NestStore {
  rootStore = null;

  /**
   * @property {Object|null}
   */
  @observable photoEditingLabel = null;

  /**
   * @property {number|null}
   */
  photoEditingJobId = null;

  /**
   * @property {number|null}
   */
  photoEditingLabelId = null;

  /**
   * @property {string}
   */
  @observable name = "";

  constructor(rootStore) {
    super();

    this.rootStore = rootStore;

    this.photoEditingLabelRepository = new PhotoEditingLabelRepository();
  }

  @action
  create() {
    if (this.name.trim() === "") {
      return Promise.resolve();
    }

    if (this.isLoading) {
      return Promise.resolve();
    }

    this.isLoading = true;

    return this.photoEditingLabelRepository
      .create({
        photoEditingJobId: this.photoEditingJobId,
        name: this.name,
      })
      .then(response => {
        this.name = "";
        const { photoEditingJobStore } = this.rootStore;
        const { photoEditingJob } = photoEditingJobStore;

        photoEditingJob.addPhotoEditingLabel(response.data.photoEditingLabel);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  @action
  delete(photoEditingLabelId) {
    const { photoEditingJobStore } = this.rootStore;
    const { photoEditingJob } = photoEditingJobStore;

    // if label doesn't exists, don't even attempt to send an xhr.
    if (!photoEditingJob.photoEditingLabels.find(label => label.photoEditingLabelId === photoEditingLabelId)) {
      return Promise.resolve();
    }

    // first delete the label from the collection, we don't want to show a spinner nor block the screen (loader)
    // when a label is deleted.
    photoEditingJob.removePhotoEditingLabelById(photoEditingLabelId);

    return this.photoEditingLabelRepository.delete(photoEditingLabelId);
  }

  @action
  onNameChange(name) {
    this.name = name;
  }
}

export default PhotoEditingLabelStore;
